export enum NftCardHeroInteriorAlignment {
    Left = 'left',
    Right = 'right',
    Center = 'center',
    SpaceBetween = 'spaceBetween',
}

export enum NftCardSectionVariant {
    Common = 'common',
    Activity = 'activity',
    Credits = 'credits',
    Hero = 'hero',
}
